.loader {
  min-height: 400px;
}

.tax-identifier-form {
  width: 100%;
}
